import React from "react";
import FaFileImageO from "react-icons/lib/fa/file-image-o";
import FaFileArchiveO from "react-icons/lib/fa/file-archive-o";
import FaFilePdfO from "react-icons/lib/fa/file-pdf-o";
import FaFileWordO from "react-icons/lib/fa/file-word-o";
import FaFileExcelO from "react-icons/lib/fa/file-excel-o";
import FaFileTextO from "react-icons/lib/fa/file-text-o";
import FaFileO from "react-icons/lib/fa/file-o";

const FileIcon = ({ fileType, size, color }) => {
	if (["png", "jpg", "jpeg", "webp", "gif", "tif"].includes(fileType)) {
		return <FaFileImageO size={size} color={color} />;
	} else if (fileType === "zip") {
		return <FaFileArchiveO size={size} color={color} />;
	} else if (fileType === "pdf") {
		return <FaFilePdfO size={size} color={color} />;
	} else if (["doc", "docm", "docx"].includes(fileType)) {
		return <FaFileWordO size={size} color={color} />;
	} else if (
		["xlsx", "xlsm", "xltx", "xltm", "xls", "xml"].includes(fileType)
	) {
		return <FaFileExcelO size={size} color={color} />;
	} else if (fileType === "txt") {
		return <FaFileTextO size={size} color={color} />;
	} else {
		return <FaFileO size={size} color={color} />;
	}
};

export default FileIcon;



// WEBPACK FOOTER //
// ./src/common/fileIcon/FileIcon.js